export const SET_LOGGED_IN = 'SET_LOGGED_IN'

export const REMOVE_LOGGED_IN = 'REMOVE_LOGGED_IN'

export const SET_USER = 'SET_USER'

export const MARK_READ_MESSAGE = 'MARK_READ_MESSAGE'

export const REMOVE_UNREAD_MESSAGE = 'REMOVE_UNREAD_MESSAGE'

export const MARK_UNREAD_MESSAGE = 'MARK_UNREAD_MESSAGE'

export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'

export const SET_REFRESH_OPTION = 'SET_REFRESH_OPTION'

export const SET_USER_TYPE = 'SET_USER_TYPE'

export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT'
export const CLEAR_CURRENT_PROJECT = 'CLEAR_CURRENT_PROJECT'
